// extracted by mini-css-extract-plugin
module.exports =  {"model-answer-container":"Template38-pF8N__model-answer-container","model-answer-title":"Template38-yM14__model-answer-title","model-answer":"Template38-Qrq8__model-answer"};